module.exports = __webpack_public_path__ + "static/img/popup2-swiper1.2bfd11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup2-swiper1.png
// module id = Y75R
// module chunks = 0